import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=66d7b6f1&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=ts&"
export * from "./AddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7b6f1",
  null
  
)

export default component.exports